export type CommunityPreviewChannel = {
  id: string;
  name: string;
  thumbnail?: string | null;
  remix_count?: number | null;
  is_autoclipper_partner?: boolean | null;
};

export type CommunityPreviewAvatar = {
  id: string;
  name: string;
  thumbnail: string | null;
};

export function pickCommunityPreviewAvatars(
  channels: CommunityPreviewChannel[],
  { limit = 5 }: { limit?: number } = {},
): { avatars: CommunityPreviewAvatar[]; totalCount: number } {
  const unique = new Map<string, CommunityPreviewAvatar & { remix: number; partner: boolean }>();

  for (const channel of channels) {
    if (!channel.id || unique.has(channel.id)) continue;
    unique.set(channel.id, {
      id: channel.id,
      name: channel.name,
      thumbnail: channel.thumbnail?.trim() || null,
      remix: channel.remix_count ?? 0,
      partner: Boolean(channel.is_autoclipper_partner),
    });
  }

  const ranked = [...unique.values()].sort((left, right) => {
    const thumbDiff = Number(Boolean(right.thumbnail)) - Number(Boolean(left.thumbnail));
    if (thumbDiff !== 0) return thumbDiff;
    if (right.remix !== left.remix) return right.remix - left.remix;
    const partnerDiff = Number(right.partner) - Number(left.partner);
    if (partnerDiff !== 0) return partnerDiff;
    return left.name.localeCompare(right.name);
  });

  return {
    avatars: ranked.slice(0, limit).map(({ id, name, thumbnail }) => ({ id, name, thumbnail })),
    totalCount: unique.size,
  };
}
